export const enum SampleOrderTypes {

    DIGITAL = 'digital',
    PHYSICAL = 'physical',

}
